import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps routes that require BOTH auth AND email verification.
 * - Not authed → /login
 * - Authed but email not verified → /verify-email (OTP page)
 */
export default function ProtectedRoute({ children, requireEmailVerified = true, requireAdmin = false, requirePartner = false, requireEventStaff = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="h-8 w-8 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to={user.role === "outlet_partner" ? "/scan" : "/dashboard"} replace />;
  }
  if (requirePartner && !["admin", "outlet_partner"].includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireEventStaff && !["admin", "event_staff"].includes(user.role)) {
    return <Navigate to={user.role === "outlet_partner" ? "/scan" : "/dashboard"} replace />;
  }
  if (!requireAdmin && !requirePartner && !requireEventStaff && user.role === "outlet_partner") {
    return <Navigate to="/scan" replace />;
  }
  if (!requireAdmin && !requirePartner && !requireEventStaff && user.role === "event_staff") {
    return <Navigate to="/event-staff/scan" replace />;
  }
  if (requireEmailVerified && user.role === "student" && !user.email_verified) {
    return <Navigate to="/verify-email" state={{ email: user.email }} replace />;
  }
  return children;
}
